<template>
  <div class="homePage">
    <div class="info-container">
      <p>你好！</p>
      <p>我是你的AI广告助手，</p>
      <p>我可以帮你快速撰写关键词、广告标题、广告说明。</p>
    </div>
    <div class="button-container">
      <el-button type="primary" @click="newJob">新的任务</el-button>
      <el-button @click="newBatchJob">新户自动化上线批量任务</el-button>
    </div>
    <div class="history">
      <historyCardList :histories="histories"></historyCardList>
    </div>
  </div>
</template>
<script>
import historyCardList from "@/components/aiAds/components/historyCardList.vue";
import {mapMutations} from "vuex";
import sem from '@/backend/services/sem/sem.js';

export default {
  name: 'homePage',
  components: {
    historyCardList
  },
  data() {
    return {
      histories: []
    }
  },
  mounted() {
    this.getHistory();
  },
  methods: {
    async getHistory() {
      let res = await sem.programmeList(
          {
            displayStart: 1,
            displayLength: 6
          }
      );
      this.histories = res.data.data;
    },
    ...mapMutations(['setCurrentPage', 'setModel', 'setCurrentInfo']),
    newJob() {
      this.setCurrentPage(2);
      this.setModel(1);
      this.setCurrentInfo({
        automationId: '',
        programmeId: '',
        serviceId: '',
        customerId: '',
      })
    },
    newBatchJob() {
      this.setCurrentPage(2);
      this.setModel(2);
      this.setCurrentInfo({
        automationId: '',
        programmeId: '',
        serviceId: '',
        customerId: '',
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.homePage {
  .info-container {
    font-size: 14px;
    color: #333;
  }

  .button-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 150px 0;

    .el-button {
      margin-bottom: 20px;
      width: 300px;
    }
  }
}
</style>